import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

// TransomCasing — shown when Transom is not None
// Shows CasingSize when a wood material is selected
const WOOD_OPTIONS = ['MDF', 'FJPine', 'Poplar', 'RedOak'];

const OPTIONS = [
  { value: 'None',    label: 'None'     },
  { value: 'MDF',     label: 'MDF'      },
  { value: 'FJPine',  label: 'FJ Pine'  },
  { value: 'Poplar',  label: 'Poplar'   },
  { value: 'RedOak',  label: 'Red Oak'  },
];

const DEFAULT = 'None';

const TransomCasing = ({ value = { value: '', label: '' }, onChange, disabled = false, onCasingSizeVisible }) => {
  const [selected, setSelected] = useState(value?.value || DEFAULT);

  useEffect(() => { setSelected(value?.value || DEFAULT); }, [value?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    const label = OPTIONS.find(o => o.value === v)?.label || v;
    setSelected(v);
    onChange({ value: v, label });
    onCasingSizeVisible?.(WOOD_OPTIONS.includes(v));
  };

  return (
    <div className="a-container">
      <label htmlFor="SdTransomCasing">Transom Casing</label>
      <select id="SdTransomCasing" value={selected} onChange={handleChange} disabled={disabled}>
        {OPTIONS.map(o => (
          <option key={o.value} value={o.value}>
            {selected === o.value ? `${o.label} ✔` : o.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TransomCasing;
